module.exports = __webpack_public_path__ + "img/success.1f13a49a.png";